import { useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import WhiteBox from '../../WhiteBox/WhiteBox';
import PricingSubscriptionSelectionModal
	from '../../../new_arch/modules/workspaces/modals/PricingSubscriptionSelectionModal/PricingSubscriptionSelectionModal';
import PlanSettingsPresenter from '../../../presenters/PlanSettings/PlanSettingsPresenter';
import SubscriptionDetailPaidPlanFooter from '../SubscriptionDetailPaidPlanFooter/SubscriptionDetailPaidPlanFooter';
import WorkspaceSubscriptionCheckoutModalContainer from '../../../containers/WorkspaceSubscriptionCheckoutModalContainer/WorkspaceSubscriptionCheckoutModalContainer';
import './SubscriptionDetail.scss';
import ActiveSubscriptionDetail from '../ActiveSubscriptionDetail/ActiveSubscriptionDetail';
import SuspendedSubscriptionDetail from '../SuspendedSubscriptionDetail/SuspendedSubscriptionDetail';

const SubscriptionDetail = ( {
	presenter
} ) => {
	useEffect( presenter.openSubscriptionModalBasedOnQueryParams, [] );

	const onUpgradePlanButton = () => {
		if ( presenter.isSubscriptionMarkedForCancellation ) {
			return presenter.onReactivateSubscriptionClicked();
		}
		return presenter.openSubscriptionModal();
	};

	const closeCheckoutModal = () => presenter.closeCheckout();

	const onSuccessfulPaymentDialogAccepted = () => {
		presenter.closeSubscriptionModal();
		presenter.closeCheckout();
	};

	const onUpgradeButtonClicked = ( aPricingPlanPrice ) => {
		if ( presenter.selectPlanMode ) {
			presenter.selectPlanInChangeMode( aPricingPlanPrice );
			return;
		}
		if ( aPricingPlanPrice.isFree ) {
			presenter.createFreeSubscription( aPricingPlanPrice );
		} else {
			presenter.openCheckout( aPricingPlanPrice );
		}
		presenter.closeSubscriptionModal();
	};

	const onDowngradeButtonClicked = () => presenter.onDowngradeClicked();

	const onCancelDowngradeButtonClicked = () => presenter.onCancelDowngradeClicked();

	const renderFooter = () => (
		<div className="footer">
			<SubscriptionDetailPaidPlanFooter
				workspace={presenter.workspace}
				isSubscriptionActive={presenter.isSubscriptionActive}
				onUpgradePlanButton={() => onUpgradePlanButton()}
				showCancelSubscriptionButton={presenter.shouldRenderCancelSubscriptionButton}
				onCancelSubscriptionClick={presenter.onSubscriptionCancelClicked}
				canAddMembersAddOn={presenter.canAddMembersAddOn}
			/>
		</div>
	);

	const renderPricingSubscriptionSelectionModal = () => (
		<PricingSubscriptionSelectionModal
			workspaceID={presenter.workspace.id}
			presenter={presenter.pricingSubscriptionPresenter}
			onClose={presenter.closeSubscriptionModal}
			onUpgradeButtonClicked={onUpgradeButtonClicked}
			onDowngradeButtonClicked={onDowngradeButtonClicked}
			onCancelDowngradeButtonClicked={onCancelDowngradeButtonClicked}
			selectPlanMode={presenter.selectPlanMode}
		/>
	);

	const renderWorkspaceSubscriptionCheckoutModal = () => (
		<WorkspaceSubscriptionCheckoutModalContainer
			workspaceID={presenter.workspace.id}
			onClose={closeCheckoutModal}
			onSuccessfulDialogAccepted={onSuccessfulPaymentDialogAccepted}
			pricingPlanPrice={presenter.checkoutPricingPlanPrice}
			memberAddOnQuantity={presenter.memberAddOnQuantity}
			checkoutTotalCost={presenter.checkoutTotalCost}
		/>
	);

	const renderSubscriptionType = () => (
		presenter.isSubscriptionActive || presenter.isOnActiveFreeTrial
			? <ActiveSubscriptionDetail presenter={presenter} />
			: <SuspendedSubscriptionDetail presenter={presenter} />
	);

	return (
		<div className={classNames( 'SubscriptionDetail', { inactive: !presenter.workspace.isActive } )}>
			<WhiteBox>
				{ presenter.subscriptionModalIsOpen && renderPricingSubscriptionSelectionModal() }
				{ presenter.isCheckoutOpen && renderWorkspaceSubscriptionCheckoutModal() }
				<div className="WhiteBoxTitle">
					<h4 style={{ fontFamily: 'Open Sans', fontSize: '14px', fontWeight: 600, lineHeight: '22px', letterSpacing: '0px', color: 'var(--color-text-primary)' }}>Plan Detail</h4>
				</div>
				{
					renderSubscriptionType()
				}
				{ renderFooter() }
			</WhiteBox>
		</div>
	);
};

SubscriptionDetail.propTypes = {
	presenter: PropTypes.instanceOf( PlanSettingsPresenter ).isRequired
};

export default observer( SubscriptionDetail );
